import React from 'react';
import { motion } from 'framer-motion';
export function ProblemSection() {
  return <section className="bg-gray-50 py-20 md:py-28 px-4" data-id="element-140">
      <div className="container mx-auto max-w-2xl text-center" data-id="element-141">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-3xl md:text-5xl font-serif font-bold text-gray-900 mb-10 leading-tight" data-id="element-142">
          Si llegaste hasta acá,
          <br className="hidden md:block" data-id="element-143" /> no fue por casualidad
        </motion.h2>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.1
      }} className="space-y-8 text-lg md:text-xl text-gray-600 leading-relaxed" data-id="element-144">
          <p className="italic text-gray-700" data-id="element-145">
            ¿Sentís que hay algo en vos que quiere sanar… pero no sabés bien por
            dónde empezar?
          </p>

          <p data-id="element-146">No es falta de espiritualidad. No es falta de sensibilidad.</p>

          <p className="text-2xl md:text-3xl font-bold text-gray-900 py-2" data-id="element-147">
            👉 Es falta de orden y guía clara.
          </p>

          <p data-id="element-148">
            Leés información suelta. Probás meditaciones. Sentís energía… pero
            dudás si lo estás haciendo bien.
          </p>

          <p className="font-semibold text-gray-900 text-xl" data-id="element-149">
            Y eso frena tu proceso…
          </p>

          <div className="w-16 h-px bg-gray-300 mx-auto" data-id="element-150"></div>

          <p className="text-xl md:text-2xl font-bold text-gray-900" data-id="element-151">
            Reiki no es complicado.
            <br data-id="element-152" />
            Lo complicado es aprenderlo sin una guía clara.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2
      }} className="mt-14 bg-white rounded-2xl p-8 md:p-10 shadow-lg border border-gray-200 text-left max-w-xl mx-auto" data-id="element-153">
          <h3 className="text-xl font-bold text-gray-900 mb-6 text-center" data-id="element-154">
            A muchas personas les pasa esto:
          </h3>
          <ul className="space-y-4 text-gray-700 text-lg" data-id="element-155">
            {['Encuentran información suelta y contradictoria', 'Practican, pero dudan si lo hacen bien', 'Les cuesta sostener constancia', 'Sienten que podrían avanzar más'].map((item, idx) => <li key={idx} className="flex items-start gap-3" data-id="element-156">
                <span className="text-red-500 font-bold text-xl leading-none mt-0.5" data-id="element-157">
                  •
                </span>
                <span data-id="element-158">{item}</span>
              </li>)}
          </ul>

          <p className="mt-8 text-lg font-bold text-gray-900 text-center" data-id="element-159">
            El problema no es la falta de sensibilidad. Es no tener un camino
            ordenado para avanzar con seguridad.
          </p>
        </motion.div>
      </div>
    </section>;
}